<template>
  <b-modal header-close-content="" body-class="view-options-modal" id="view-options-modal" :title="$t('menubar.view')" ok-only>
    <div class="section-wrapper">
      <div class="settings-group">
        <div class="settings-group-title">{{ $t("languages") }}</div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsFallbackHintVisible" switch data-cy="attribute-manager-contextmenu-fallback-languge-hint-checkbox">{{
            $t("ShowFallbackLanguageHint")
          }}</b-form-checkbox>
        </div>
      </div>
      <div class="settings-group">
        <div class="settings-group-title">{{ $t("advanced") }}</div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsUidVisible" switch data-cy="attribute-manager-contextmenu-attribute-id-checkbox">{{
            $t("AttributeIds")
          }}</b-form-checkbox>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      settings: {
        IsUidVisible: false,
        IsFallbackHintVisible: false
      }
    };
  },
  computed: {
    ...mapState(["userSettings"])
  },
  methods: {
    ...mapActions(["saveUserSettings"])
  },
  watch: {
    settings: {
      deep: true,
      handler(nv) {
        this.saveUserSettings(nv);
      }
    },
    userSettings: {
      immediate: true,
      deep: true,
      handler(nv) {
        if (!nv) return;

        Object.assign(this.settings, {
          IsUidVisible: nv.IsUidVisible === true || nv.IsUidVisible === "true",
          IsFallbackHintVisible: nv.IsFallbackHintVisible === true || nv.IsFallbackHintVisible === "true" || nv.IsFallbackHintVisible === undefined
        });
      }
    }
  }
};
</script>
